import { Typography } from '@material-ui/core';
import React from 'react';
import { makeStyles } from '@material-ui/styles';
const useStyles = makeStyles(() => ({
  textStyle: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '12px',
    lineHeight: '21px',
    color: '#000000',
  },
}));
const PopupContentText = (props) => {
  const classes = useStyles();
  return <Typography className={classes.textStyle}>{props.text}</Typography>;
};

export default PopupContentText;
